import React, { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import MandatoryScopes from '../../../../../../constants/MandatoryScopes'
import ClientTypesConstants from '../../../../../../constants/ClientTypes'
import CopiedElement from '../../../../CopiedElement'
import './style.sass'

const CopyClientScopes = ({ clientType, appScopes = [] }) => {
  // ===== Local State =====
  const [showCopied, setShowCopied] = useState(false)

  // ===== Methods =====
  const getClientScopesAsString = () => {
    const clientScopes = [MandatoryScopes.APPFRAMEWORK, ...appScopes?.map(scope => scope.value)]

    // SPA, WEB and MOBILE clients should have the openid and profile scopes also when copied
    if (clientType !== ClientTypesConstants.SERVER) {
      clientScopes.push("openid")
      clientScopes.push("profile")
    }
    // WEB and MOBILE clients should have the offline_access scope also when copied
    if (clientType === ClientTypesConstants.WEB || clientType === ClientTypesConstants.MOBILE) {
      clientScopes.push("offline_access")
    }

    return clientScopes?.toString()?.replaceAll(",", " ")
  }

  return (
    <div className="copy-client-scopes-component-container">
      <p className="copy-client-scopes-field-label">To use this client, you need the client scopes</p>
      <CopyToClipboard text={getClientScopesAsString()} onCopy={() => {
        setShowCopied(true)
        getClientScopesAsString() // TODO REMOVE THIS
      }}>
        <div className="copy-client-scopes-btn-container">
          <p className="copy-client-scopes-btn">
            <i className="fa fa-copy"></i>
            Copy client scopes 
          </p>
          {showCopied && <CopiedElement isAbsolute={false} onTimout={() => setShowCopied(false)} />}
        </div>
      </CopyToClipboard>
    </div>
  )
}

export default CopyClientScopes
